import * as React from 'react'

import { FinanceSpendingInvoicesSubModuleRoutesVisibilityDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildNavigation } from 'modules/core/lib/react-router'

import ReroutingIndex from 'modules/finance/pages/ReroutingIndex'

const BankingReconciliationFromInvoiceSidePanel = React.lazy(
  () => import('modules/banking/components/BankingReconciliationFromInvoiceSidepanel')
)

const EmptyMessageContentPage = React.lazy(
  () => import('modules/finance/pages/EmptyMessageContentPage')
)
const InvoicesExporterSidePanel = React.lazy(
  () => import('modules/finance/components/InvoicesExporterSidePanel')
)
const InboxPage = React.lazy(() => import('modules/finance/pages/InboxPage'))
const InvoiceDetailPage = React.lazy(() => import('modules/finance/pages/InvoiceDetailPage'))
const InvoicesPage = React.lazy(() => import('modules/finance/pages/InvoicesPage'))

const MessageContentPage = React.lazy(() => import('modules/finance/pages/MessageContentPage'))

export const purchaseInvoicesRoutes = buildNavigation((navigation) => {
  return [
    {
      path: navigation.finance.spending.invoices.path,
      handle: {
        meta: ({ watchQuery }) => {
          return watchQuery({
            query: FinanceSpendingInvoicesSubModuleRoutesVisibilityDocument,
          }).map(({ data }) => {
            const canCreatePurchaseFinancialDocuments =
              data.finance._policies?.financialDocumentsCreatePurchase?.can ?? false

            return {
              subNavigation: [
                {
                  id: 'invoices',
                  title: i18n.t('finance.invoices.subtabs.invoices'),
                  href: navigation.finance.spending.invoices.list.fullPath(),
                  isVisible: true,
                },
                {
                  id: 'inbox',
                  title: i18n.t('finance.invoices.subtabs.mailbox_without_counter'),
                  href: navigation.finance.spending.invoices.inbox.fullPath(),
                  isVisible: canCreatePurchaseFinancialDocuments,
                },
              ],
            }
          })
        },
      },
      children: [
        {
          index: true,
          element: <ReroutingIndex />,
        },
        {
          path: navigation.finance.spending.invoices.list.path,
          element: <InvoicesPage />,
          handle: {
            meta: () => ({
              description: i18n.t('finance.invoices.list.description'),
              title: i18n.t('finance.invoices.title'),
              illustration: 'list-document',
            }),
          },
          children: [
            {
              path: navigation.finance.spending.invoices.list.exporter.path,
              element: <InvoicesExporterSidePanel />,
            },
            {
              path: navigation.finance.spending.invoices.list.invoiceId.path,
              element: <InvoiceDetailPage />,
              children: [
                {
                  path: navigation.finance.spending.invoices.list.invoiceId.reconciliations.path,
                  element: <BankingReconciliationFromInvoiceSidePanel />,
                  handle: {
                    meta: () => ({ title: i18n.t('banking.accounts.reconciliations') }),
                  },
                },
              ],
            },
          ],
        },
        {
          path: navigation.finance.spending.invoices.inbox.path,
          element: <InboxPage />,
          handle: {
            meta: () => ({
              title: i18n.t('finance.invoices.mailbox'),
              illustration: 'send-email-envelope',
            }),
          },
          children: [
            {
              index: true,
              element: <EmptyMessageContentPage />,
            },
            {
              path: navigation.finance.spending.invoices.inbox.messageId.path,
              element: <MessageContentPage />,
            },
          ],
        },
      ],
    },
  ]
})
